import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const steps = [
  { num: '01', title: 'Apply', desc: 'Submit your facility details — location, freezing technology, capacity, and certifications. Takes 10 minutes.', icon: 'ri-file-text-line' },
  { num: '02', title: 'Audit & Certification', desc: 'Our team visits your facility for verification. We assign your trust tier: Verified, HACCP-Certified, or Export-Grade.', icon: 'ri-search-eye-line' },
  { num: '03', title: 'List Capacity', desc: 'Set your availability, pricing preferences, and service radius. Your facility goes live on the network within 48 hours of approval.', icon: 'ri-upload-cloud-line' },
  { num: '04', title: 'Start Earning', desc: 'Get matched with demand. Receive bookings, manage through the dashboard, and get paid weekly.', icon: 'ri-money-rupee-circle-line' },
];

export default function OnboardingSteps() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 warm-sand-bg">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
            Getting Started
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            Onboard in Four Steps
          </h2>
          <p className="text-foreground-500 max-w-lg mx-auto">
            From application to your first booking — we move fast because your capacity shouldn&apos;t sit idle.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {steps.map((step, idx) => (
            <div key={step.num} className="relative flex items-start gap-6 pb-10 last:pb-0 card-animate">
              {/* Connector line */}
              {idx < steps.length - 1 && (
                <div className="absolute left-[27px] top-[56px] w-0.5 h-[calc(100%-28px)] bg-secondary-200"></div>
              )}

              {/* Step number circle */}
              <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-500 text-paper-50 font-heading font-bold text-lg z-10">
                {step.num}
              </div>

              <div className="pt-1 flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                    <i className={`${step.icon} text-sm`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-primary-700 text-lg">{step.title}</h3>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed ml-11">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            Start Your Application
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}